import { render, staticRenderFns } from "./ProdutosSugestaoCompra.vue?vue&type=template&id=6ca5213a&scoped=true"
import script from "./ProdutosSugestaoCompra.vue?vue&type=script&lang=js"
export * from "./ProdutosSugestaoCompra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca5213a",
  null
  
)

export default component.exports